module.exports = __webpack_public_path__ + "img/dji.4c29861b.jpg";